import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

export interface IRadioItem {
	value: number;
	display: string;
	tooltip?: string;
}

@Component({
	selector: "radio-group",
	template: `
		<div [className]="classes" *ngFor="let item of radioItems;let i=index;">
			<div class="radio" [ngClass]="divClass()" [attr.data-automation-radio-group-div-class-div]="i">
				<label class="icheck-label" data-toggle="tooltip" data-placement="top" [attr.data-original-title]="item.tooltip" [attr.data-automation-radio-group-label]="i">
					<span class="iradio_flat-green iradio_flat-inline" [ngClass]="spanClass(item)" [attr.data-automation-radio-group-span]="i">
						<input class="icheck icheck-inline" type="radio"
							[name]="name"
							[value]="item.value"
							[(ngModel)]="model"
							disabled="{{!editable}}"
							(ngModelChange)="onChange()"
							[attr.data-automation-radio-group-input]="i">
						<ins class="iCheck-helper iCheck-helper-inline"></ins>
					</span>
					{{item.display}}
				</label>
			</div>
		</div>
	`,
	styles: [`
		.iradio_flat-inline {
			position: relative;
		}
		.iradio_flat-green {
		}
		.icheck-inline {
			position: absolute;
			opacity: 0;
		}
		.iCheck-helper-inline {
			position: absolute;
			top: 0%;
			left: 0%;
			display: block;
			width: 100%;
			height: 100%;
			margin: 0px;
			padding: 0px;
			background: rgb(255, 255, 255);
			border: 0px;
			opacity: 0;
		}
	`]
})
export class RadioGroupComponent implements OnInit {
	@Input() name: string;
	@Input() model: number;
	@Input() radioItems: IRadioItem[];
	@Input() editable: boolean;
	@Input() classes?: string;

	@Output() radioChanged = new EventEmitter<number>();

	ngOnInit() { this.onChange(); }

	onChange() { if (this.editable) { this.radioChanged.emit(this.model); } }

	divClass() {
		return {
			"disabled": !this.editable
		};
	}
	spanClass(item: IRadioItem) {
		return {
			"checked": this.model === item.value,
			"iradio_flat-aero": !this.editable
		};
	}
}
